import { MicNone } from "@mui/icons-material";
import React, { memo } from "react";

import { getBackendUrl } from "../../../config";
import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();
  const link = getBackendUrl();

  return (
    <NodeCard color="#0891b2" icon={<MicNone />} title="Áudio" id={id} width={300}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <audio controls="controls" className="nodrag" style={{ display: "block", width: "100%", height: 36 }}>
        <source src={`${link}/public/${data.url}`} type="audio/mp3" />
        seu navegador não suporta HTML5
      </audio>
      <div className={classes.hint}>{data.record ? "Gravado na hora" : "Áudio enviado"}</div>
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
